import httpRequest from "../utils/httpRequest";
import httpRequestScoring from "../utils/httpRequestScoring";
import endpoints from "./endpoints";

export const getHighlightArticle = (region) => {
  return httpRequest.get(endpoints.getHighlightArticle, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getGalleryArticle = (region) => {
  return httpRequest.get(endpoints.getGalleryArticle, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getDetailArticle = (slug, region) => {
  return httpRequest.get(endpoints.getDetailArticle, {
    params: { slug, region: region?.replace(" ", "-") },
  });
};

export const getScheduleMatch = (region, category) => {
  return httpRequest.get(endpoints.getScheduleMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getGroupMatch = (region, category) => {
  return httpRequest.get(endpoints.getGroupMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getKnockoutMatch = (region, category) => {
  return httpRequest.get(endpoints.getKnockoutMatch, {
    params: { region: region?.replace(" ", "-"), category },
  });
};

export const getWhatsNew = (region) => {
  return httpRequest.get(endpoints.getWhatsNew, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getVenue = (region) => {
  return httpRequest.get(endpoints.getVenue, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEvent = (region) => {
  return httpRequest.get(endpoints.getEvent, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEventJourney = () => {
  return httpRequest.get(endpoints.getJourney);
};

export const getEventDetail = (region) => {
  return httpRequest.get(endpoints.getEventDetail, {
    params: { region: region?.replace(" ", "-") },
  });
};

export const getEventSeries = () => {
  return httpRequest.get(endpoints?.getEventSeries);
};

export const getEventRegionSeries = () => {
  return httpRequest.get(endpoints?.getRegionEventSeries);
};

export const getEventSeriesDetail = (slug) => {
  return httpRequest.get(endpoints?.getEventSeriesDetail(slug.replace(" ", "-")));
};

export const getSection = () => {
  return httpRequest.get(endpoints?.getSection);
};

export const getEventHallOfFame = (slug) => {
  return httpRequest.get(endpoints?.getHallOfFame(slug.replace(" ", "-")));
};

export const getTimelineSeries = (slug) => {
  return httpRequest.get(endpoints?.getTimeline(slug.replace(" ", "-")));
};

export const postRegistrationForm = (payload) => {
  return httpRequest.post(endpoints?.postRegister, payload);
};

export const postRegistrationDanceForm = (payload) => {
  return httpRequest.post(endpoints?.postRegisterDance, payload);
};

export const postLogin = (data) => {
  return httpRequest.post(endpoints?.login, {
    email: data?.email,
    password: data?.password,
  });
};

export const getRegionGallery = (data) => {
  return httpRequest.get(endpoints?.getRegionGallery, {
    params: {
      year: data?.year,
      main_region: data?.main_region,
    },
  });
};

export const getYearsGallery = (data) => {
  return httpRequest.get(endpoints?.getYearsGallery, {
    params: {
      main_region: data?.main_region,
    },
  });
};

export const getCurrentRegistrationData = () => {
  return httpRequest.get(endpoints?.getCurrentRegistration);
};

export const postUpdateData = (payload) => {
  return httpRequest.post(endpoints?.postUpdateRegister, payload);
};

export const postUpdateDanceData = (payload) => {
  return httpRequest.post(endpoints?.postUpdateDanceRegistration, payload);
};

export const postAddPlayer = ({ eventRegistrationId, payload }) => {
  return httpRequest.post(endpoints?.postAddPlayer(eventRegistrationId), payload);
};

export const postAddDancer = ({ eventRegistrationId, payload }) => {
  return httpRequest.post(endpoints?.postAddDanceMember(eventRegistrationId), payload);
};

export const getPaymentDetail = (region_id, school_category) => {
  return httpRequest.get(endpoints?.paymentDetail(), {
    params: { region_id },
  });
};

export const postProofPayment = (payload) => {
  const { registrationId: event_registration_id, formData } = payload;
  return httpRequest.post(endpoints?.postProofPayment(event_registration_id), formData);
};

export const postUpdatePaymentExpired = (payload) => {
  const { registrationId: event_registration_id } = payload;
  return httpRequest.post(endpoints?.postUpdatePaymentExpired(event_registration_id));
};

//LapangBola LiveScore
export const postTokenLiveScore = () => {
  return httpRequest.post(endpoints?.getTokenLiveScore, {
    username: process.env.REACT_APP_LAPANGBOLA_UNAME,
    password: process.env.REACT_APP_LAPANGBOLA_PWD,
  });
};

export const getListOfClub = () => {
  return httpRequest.get(endpoints?.getListOfClub, {
    headers: {
      "User-Agent": "pialabyu.com",
    },
    // hardcode dulu
    data: {
      competition_id: 27476,
      // last_update: new Date("2024-10-07"),
    },
  });
};

export const getCompetititonList = () => {
  return httpRequest.get(endpoints?.getCompetitionList, {
    data: {
      last_update: new Date("2024-10-07"),
    },
  });
};

export const getMatches = (params) => {
  return httpRequest.get(endpoints?.getMatches, {
    params: {
      competition_id: params?.competition_id,
      start_date: params?.start_date,
      end_date: params?.end_date,
    },
  });
};

export const getMatchesDetail = (id) => {
  return httpRequest.get(endpoints?.getMatchesDetail(id));
};

export const getLiveMatchesDetail = (id) => {
  return httpRequest.get(endpoints?.getLiveMatchesDetail(id));
};

export const getCompetitionsDetail = (competition_id) => {
  return httpRequest.get(endpoints?.getClassmentsDetail(competition_id));
};

export const getCompetitionsDetailV2 = (region_id) => {
  return httpRequest.get(endpoints?.getClassmentsDetailV2, {
    params: {
      region_id,
    },
  });
};

export const getKnockoutBracket = (region_id) => {
  return httpRequest.get(endpoints?.getKnockoutBracket, {
    params: {
      region_id,
    },
  });
};

export const getMainRegionGallery = (year) => {
  return httpRequest.get(endpoints?.getMainRegionGallery, {
    params: {
      year,
    },
  });
};

export const getSocAttribute = () => {
  return httpRequest.get(endpoints?.getSocAttribute);
};

export const getTimelineSoc = () => {
  return httpRequest.get(endpoints?.getTimelineSoc);
};

export const getMainRegionSoc = () => {
  return httpRequest.get(endpoints?.getMainRegionSoc, {
    params: {
      has_champion: true,
    },
  });
};

export const getSocChampions = (params) => {
  return httpRequest.get(endpoints?.getSocChampions, {
    params: {
      region: params?.region,
      year: params?.year,
    },
  });
};

export const getMatchTopStats = (params) => {
  return httpRequest.get(endpoints?.getMatchTopStats, {
    params: {
      match_id: params?.matchId,
      player_statistic_id: params?.playerStatisticId,
    },
  });
};

export const getCurrentEventSeries = (category) => {
  return httpRequest.get(endpoints?.getCurrentEventSeries, {
    params: { category },
  });
};

export const getEventCategory = () => {
  return httpRequest.get(endpoints?.getEventCategory);
};

export const getMatchList = (region_id) => {
  return httpRequest.get(endpoints?.getMatchList, {
    params: {
      region_id,
    },
  });
};

export const getMatchDetail = (match_schedule_id) => {
  return httpRequest.get(endpoints?.getMatchDetail, {
    params: {
      match_schedule_id,
    },
  });
};

export const getVideos = (region) => {
  return httpRequest.get(endpoints?.getVideos, {
    params: {
      region,
    },
  });
};

export const getActivity = (region) => {
  return httpRequest.get(endpoints?.getActivity, {
    params: {
      region,
    },
  });
};

export const getActivityDetail = (payload) => {
  const { slug, region } = payload;
  return httpRequest.get(endpoints?.getActivityDetail, {
    params: { slug, region: region?.replace(" ", "-") },
  });
};
